import React from 'react';
import { CheckCircle2, AlertTriangle, Info, XCircle, X } from 'lucide-react';
import { InlineAlertProps } from './InlineAlert.types';

const typeConfig: Record<
  InlineAlertProps['type'],
  { icon: React.ComponentType<{ className?: string }>; textColor: string; bgColor: string; borderColor: string }
> = {
  success: {
    icon: CheckCircle2,
    textColor: 'text-green-400',
    bgColor: 'bg-green-500/10',
    borderColor: 'border-green-500/20',
  },
  error: {
    icon: XCircle,
    textColor: 'text-red-300',
    bgColor: 'bg-red-500/20',
    borderColor: 'border-red-400/50',
  },
  warning: {
    icon: AlertTriangle,
    textColor: 'text-yellow-400',
    bgColor: 'bg-yellow-500/10',
    borderColor: 'border-yellow-500/20',
  },
  info: {
    icon: Info,
    textColor: 'text-blue-400',
    bgColor: 'bg-blue-500/10',
    borderColor: 'border-blue-500/20',
  },
};

export function InlineAlert({
  type,
  message,
  title,
  icon: CustomIcon,
  dismissible = false,
  onDismiss,
  className = '',
}: InlineAlertProps) {
  const config = typeConfig[type];
  const Icon = CustomIcon || config.icon;

  const combinedClasses = `flex items-center gap-1 ${config.textColor} ${config.bgColor} px-2 py-1 rounded border ${config.borderColor} ${className}`.trim();

  return (
    <div className={combinedClasses}>
      <Icon className="w-3 h-3 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        {title && <div className="font-medium text-xs">{title}</div>}
        <div className="text-xs">{message}</div>
      </div>
      {dismissible && onDismiss && (
        <button
          onClick={onDismiss}
          className="ml-1 p-0.5 hover:opacity-70 transition-opacity flex-shrink-0"
          aria-label="Fechar"
        >
          <X className="w-3 h-3" />
        </button>
      )}
    </div>
  );
}

